/**
 * Notification service for CameraCapture. Injected for testability and app consistency.
 * Default implementation uses the app's notify (utils/notify).
 */

import { notify } from "../../../shared/utils/notify";

const DEFAULT_DURATION = 3;

/**
 * @typedef {Object} NotificationService
 * @property {(message: string, description?: string) => void} warn
 * @property {(message: string, description?: string) => void} error
 */

/**
 * Default notification service (non-blocking toasts).
 * @type {NotificationService}
 */
export const defaultNotificationService = {
  warn(message, description = "") {
    notify.warning({ message, description, duration: DEFAULT_DURATION });
  },
  error(message, description = "") {
    notify.error({ message, description, duration: DEFAULT_DURATION });
  },
};

/**
 * @param {NotificationService | null | undefined} injected
 * @returns {NotificationService}
 */
export function getNotificationService(injected) {
  return injected && typeof injected.warn === "function" ? injected : defaultNotificationService;
}
